module.exports = __webpack_public_path__ + "img/002.c591d7c5.png";